// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

// Internal Dependencies:
import Editable from 'components/Editable/Editable'
import SidebarLogin from 'components/Login/SidebarLogin'

class Content extends React.Component {
	render() {
		const { page } = this.props

		if ( ! page ) {
			return null
		}

		const contentBodyClass = page.content_full_width ? 'content-body-full' : 'content-body'
		let subTitle,
			image,
			intro
		const titleClass = page.title.raw.length > 60 ? 'is-long' : ''
		const introClass = page.intro.raw.length > 300 ? 'page-intro is-long' : 'page-intro'

		const title = (
			<Editable
				id="page_title"
				element="h1"
				className={ titleClass }
				content={ page.title.raw }
			/>
		)

		if ( page.subtitle && page.subtitle.rendered ) {
			subTitle = (
				<Editable
					id="page_subtitle"
					element="h2"
					className=""
					content={ page.subtitle.rendered }
				/>
			)
		}

		if ( page.intro.rendered ) {
			intro = (
				<div className={ introClass } dangerouslySetInnerHTML={ { __html: page.intro.rendered } }></div>
			)
		}

		const content = (
			<div className="content-body-wrap">
				<div className="content-body">
					{ ( ! page.title.hide || subTitle || intro ) &&
						<div className="page-title">
							{ ! page.title.hide && title }

							{ subTitle }

							{ intro }
						</div>
					}

					<Editable
						id="page_content"
						className="content-body-text"
						content={ page.content.rendered }
					/>

					{ page.notes.rendered &&
						<div className='content-notes' dangerouslySetInnerHTML={ { __html: page.notes.rendered } }></div>
					}
				</div>

				{ page.is_403 &&
					<div className="wide-section wide-section-login">
						<h3>Login or register to access the resources</h3>

						<form className="form" name="loginform" id="loginform" action={ siteData.login_action_url } method="post">
							<p className="login-username">
								<label htmlFor="user_login">Email</label>
								<input type="text" name="log" id="user_login" className="input" size="20" />
							</p>

							<p className="login-password">
								<label htmlFor="user_pass">Password</label>
								<input type="password" name="pwd" id="user_pass" className="input" size="20" />
							</p>

							<p className="login-submit">
								<button name="wp-submit" id="wp-submit" className="button">Log in</button>
								<input type="hidden" name="redirect_to" value={ siteData.site_url } />
							</p>
						</form>

						<div className="-create">
							<p>
								<span>Don't have an account?</span><br />
								<a className="button" href={ siteData.create_account_url } target="_blank" noopener="true">Sign up here</a>
							</p>
						</div>

						<div className="-note">
							<p>
								By using this website you agree to the <Link to="/terms">Terms and Conditions</Link>.
							</p>
						</div>
					</div>
				}
			</div>
		)

		return (
			<div className="page-section">
				{ content }
			</div>
		)

		// return page.content.rendered && (
		// 	<div className="page-section">
		// 		{ content }
		// 	</div>
		// ) || null
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		page: state.page.selected
	}
}

const mapDispatchToProps = ( dispatch, ownProps ) => {
	return {

	}
}

export default connect( mapStateToProps, mapDispatchToProps )( Content )



// WEBPACK FOOTER //
// ./views/main/page/Content.jsx